<template>
  <div class="login_contenter">
    <loginHeader></loginHeader>
    <div class="login_content" :class="{isPopFrame}">
      <div class="login_cont">
        <div class="login_form">
          <closeModalBtn ref="closeModalBtn"/>
          <div class="login_item">
            <div class="login_type">
              <span class="login_type_item active">{{ $t('ZhongZhiMiMa') }}</span>
            </div>
            <div class="login_form_cont">
              <el-form :rules="rules" ref="forgetPwdForm" :model="pwdForm" label-width="0px" size="medium">
                <el-form-item prop="tel">
                  <el-input v-model="pwdForm.tel" :placeholder="$t('ShouJiHaoYouXiang')" :readonly="btnStatus.forgetPwdBtn || forAutoComplete"></el-input>
                </el-form-item>
                <el-form-item prop="verificationCode" v-if="showCaptcha.forgetPassword">
                  <el-input v-model="pwdForm.verificationCode" :placeholder="$t('TuXingYanZhengMa')" style="width: calc(100% - 150px);" :readonly="btnStatus.forgetPwdBtn || forAutoComplete" maxlength="6"></el-input>
                  <img class="imgCode" @click="loginChangeCodeFn('pwdNoteImgCode')" :src="imgCodeData.pwdNoteImgCode" :alt="$t('YanZhengMa')" :title="$t('DianJiQieHuanYanZhengMa')">
                </el-form-item>
                <el-form-item prop="telVerificationCode">
                  <el-input v-model="pwdForm.telVerificationCode" :placeholder="$t('YanZhengMa')" maxlength="6" :readonly="btnStatus.forgetPwdBtn || forAutoComplete"></el-input>
                  <el-button class="getNoteCodeBtn" type="text" @click="getNoteCode" :disabled="noteCodeBtn">{{telCodeText}}</el-button>
                </el-form-item>
                <el-form-item prop="telPwd">
                  <el-input v-model="pwdForm.telPwd" :placeholder="$t('MiMa')" :type="!showPwdIcon?'password':'text'" :readonly="btnStatus.forgetPwdBtn || forAutoComplete" clearable>
                    <i slot="suffix" class="el-input__icon iconfont" @click="showPwdFn" :class="{'yyq-icon-hide': !showPwdIcon, 'yyq-icon-view': showPwdIcon}"></i>
                  </el-input>
                </el-form-item>
                <el-form-item prop="telConfirmPwd">
                  <el-input v-model="pwdForm.telConfirmPwd" :placeholder="$t('QueRenMiMa')" :type="!showPwdCIcon?'password':'text'" :readonly="btnStatus.forgetPwdBtn || forAutoComplete" clearable>
                    <i slot="suffix" class="el-input__icon iconfont" @click="showPwdCFn" :class="{'yyq-icon-hide': !showPwdCIcon, 'yyq-icon-view': showPwdCIcon}"></i>
                  </el-input>
                </el-form-item>
                <el-form-item size="large" style="margin-bottom: 0;">
                  <el-button type="primary" class="loginBtn" @click="forgetPwdSubmit" :loading="btnStatus.forgetPwdBtn">{{ $t('QueRenZhongZhiBingDengLu') }}</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div class="sy_login_bottom sy_text_c">
              <i18n path="JiDeMiMa">
                <template #link>
                  <a type="primary" @click="toPath('/')" href="javascript:;">{{ $t('QuDengLu') }} <i class="el-icon-right"></i></a>
                </template>
              </i18n>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <loginFooter></loginFooter>-->
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import loginHeader from '@/components/loginPublic/loginHeader'
import loginFooter from '@/components/loginPublic/loginFooter'
export default {
  name: 'forgetPwd',
  components: { loginHeader, loginFooter },
  data () {
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('QingShuRuTuXingYanZhengMa')))
      } else if (!(/^\S{4}$/).test(value)) {
        callback(new Error(this.$t('TuXingYanZhengMaCuoWuQingZhongXinShuRu')))
      } else {
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('QingShuRuYanZhengMa')))
      } else if (!(/^[0-9]{6}$/).test(value)) {
        callback(new Error(this.$t('YanZhengMaCuoWuQingZhongXinShuRu')))
      } else {
        callback()
      }
    }
    var checktel = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('QingShuRuShouJiHao')))
      }
      if (!(/^1[3-9][0-9]{9}$/).test(value)) {
        callback(new Error(this.$t('QingShuRuZhengQueDeShouJiHao')))
      } else {
        this.getUserIsExistFn(value).then((res) => {
          if (res.success) {
            callback(new Error(this.$t('GaiShouJiHaoWeiZhuCe')))
          } else {
            callback()
          }
        }).catch(() => {
          callback()
        })
      }
    }
    var checkTelEmail = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('QingShuRuShouJiHaoYouXiang')))
      } else if (!(/^1[3-9][0-9]{9}$/).test(value) && !/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)) {
        callback(new Error(this.$t('QingShuRuZhengQueDeShouJiHaoYouXiang')))
      } else {
        this.getUserIsExistFn(value).then((res) => {
          if (res.success) {
            callback(new Error(this.$t('GaiShouJiHaoYouXiangWeiZhuCe')))
          } else {
            callback()
          }
        }).catch(() => {
          callback()
        })
      }
    }
    var validatePwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('QingShuRuMiMa816WeiDeMiMaShuZiZiMuZiFuZhiShaoBaoHanLiangZhong')))
      } else if (!(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z-`=\[\];',.~!@#$%^&*()_+|{}:"?]{8,16}$/).test(value)) {
        callback(new Error(this.$t('QingShuRuMiMa816WeiDeMiMaShuZiZiMuZiFuZhiShaoBaoHanLiangZhong')))
      } else {
        this.getUserCheckPsdFn(value).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback(new Error(this.$t('QingShuRuMiMa816WeiDeMiMaShuZiZiMuZiFuZhiShaoBaoHanLiangZhong')))
          }
        }).catch(() => {
          callback()
        })
      }
    }
    var validateConfirmPwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('QingZaiCiShuRuMiMa')))
      } else if (value !== this.pwdForm.telPwd) {
        callback(new Error(this.$t('LiangCiShuRuMiMaBuYiZhi')))
      } else {
        callback()
      }
    }
    return {
      codeTimer: 0,
      noteCodeInterval: null,
      noteCodeBtn: false,
      forAutoComplete: true,
      // sending: '60秒后重新发送'
      pwdForm: {
        tel: '',
        verificationCode: '',
        telVerificationCode: '',
        telPwd: '',
        telConfirmPwd: ''
      },
      showPwdIcon: false,
      showPwdCIcon: false,
      rules: {
        tel: [
          { validator: checkTelEmail, trigger: 'blur' }
        ],
        verificationCode: [
          { validator: validatePass, trigger: 'blur' }
        ],
        telVerificationCode: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        telPwd: [
          { validator: validatePwd, trigger: 'blur' }
        ],
        telConfirmPwd: [
          { validator: validateConfirmPwd, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    ...mapMutations(['showMsg']),
    ...mapActions(['loginChangeCodeFn', 'getNoteCodeFn', 'forgetPwdLoginFn', 'pwdLoginFn', 'getUserIsExistFn', 'getUserCheckPsdFn']),
    showPwdFn () {
      this.showPwdIcon = !this.showPwdIcon
    },
    showPwdCFn () {
      this.showPwdCIcon = !this.showPwdCIcon
    },
    getTelCode () {
      this.NoteCodeData.forgetPwdNoteCodeKey = ''
      this.getNoteCodeFn({
        imageCode: this.pwdForm.verificationCode,
        imageCodeKey: this.imgCodeData.pwdNoteImgCodeKey,
        account: this.pwdForm.tel,
        origin: 'forgetPassword'
      }).then((response) => {
        this.NoteCodeData.forgetPwdNoteCodeKey = response.data.SMSCodeKey
        this.codeTimer = 120
        this.noteCodeBtn = true
        this.noteCodeInterval = setInterval(() => {
          if (this.codeTimer > 0) {
            this.codeTimer--
          } else {
            this.noteCodeBtn = false
            clearInterval(this.noteCodeInterval)
          }
        }, 1000)
      }).catch((response) => {
        this.loginChangeCodeFn('pwdNoteImgCode')
        this.noteCodeBtn = false
      })
    },
    getNoteCode () {
      this.noteCodeBtn = true
      this.$refs.forgetPwdForm.validateField('tel', (val, item) => {
        if (!val) {
          if (this.showCaptcha.forgetPassword) {
            this.$refs.forgetPwdForm.validateField('verificationCode', (val, item) => {
              if (!val) {
                this.getTelCode()
              } else {
                this.noteCodeBtn = false
              }
            })
          } else {
            this.getTelCode()
          }
        } else {
          this.noteCodeBtn = false
        }
      })
    },
    forgetPwdSubmit () {
      this.$refs.forgetPwdForm.validate((valid) => {
        if (valid) {
          let fpwdData = {
            userAccount: this.pwdForm.tel,
            userPassword: this.pwdForm.telPwd,
            code: this.pwdForm.telVerificationCode,
            codeKey: this.NoteCodeData.forgetPwdNoteCodeKey,
            source: this.loginSource.buryingPoint
          }
          this.forgetPwdLoginFn(fpwdData).then((res) => {
            let pwdData = {
              userAccount: this.pwdForm.tel,
              password: this.util.encodeToBase64(this.pwdForm.telPwd),
              code: '',
              codeKey: ''
            }
            this.pwdLoginFn(pwdData).then((res) => {
              let token = res.data.Authentication
              this.setCookie('DTRANXTOKEN', token)
              if (this.isPopFrame) {
                this.$refs.closeModalBtn.sendMsgOfSuccess(token)
              } else {
                window.location.href = `${this.loginSource.url}`
              }
            }).catch(() => {})
          }).catch(() => {})
        } else {
          return false
        }
      })
    },
    toPath (item) {
      this.$router.push(item)
    }
  },
  mounted () {
    let that = this
    window.onkeydown = function (event) {
      let e = event || window.event
      if (e.type === 'keydown' && (e.code === 'Enter' || e.code === 'NumpadEnter')) {
        e.preventDefault()
        if (!that.btnStatus.forgetPwdBtn) {
          that.forgetPwdSubmit()
        }
      }
    }
  },
  destroyed () {
    window.onkeydown = null
    clearInterval(this.noteCodeInterval)
  },
  created () {
    setTimeout(() => {
      this.forAutoComplete = false
      this.pwdForm.telVerificationCode = ''
      this.pwdForm.telPwd = ''
      this.pwdForm.telConfirmPwd = ''
    }, 1000)
  },
  computed: {
    ...mapState({
      isPopFrame: state => state.publicModules.isPopFrame,
      loginSource: state => state.publicModules.loginSource,
      modal: state => state.loginPublic.modal,
      imgCodeData: state => state.loginPublic.imgCodeData,
      NoteCodeData: state => state.loginPublic.NoteCodeData,
      btnStatus: state => state.loginPublic.btnStatus,
      showCaptcha: state => state.loginPublic.showCaptcha
    }),
    telCodeText () {
      if (this.codeTimer > 0) {
        return this.$t('TimerMiaoHouZhongXinFaSong', [this.codeTimer])
      }
      return this.$t('HuoQuYanZhengMa')
    }
  }
}
</script>

<style scoped lang="scss">
@media (min-width: 500px) {
  .login_content{
    min-height: 736px;
    &.isPopFrame{
      min-height: 615px;
    }
  }
}
@media (max-width: 499px) {
  .login_contenter{
    .login_content{
      .login_cont{
        .login_form{
          .login_form_cont{
            min-height: 406px;
          }
        }
      }
    }
  }
}
</style>
